import type { Func, Predicate } from '@ricoh/ria.client.core/types/core/function.type';

import type { DatabaseStorage, DatabaseStorageStore } from './_storage.type';

import storageApi from './_api';

/**
 * Create DatabaseStorage.
 *
 * @param {string} name Storage name.
 * @param {number} version Storage version.
 * @param {Func<[db: IDBDatabase]>} migrate Storage migrate.
 *
 * @returns {DatabaseStorage} DatabaseStorage.
 */
export default function createDatabaseStorage(name: string, version: number, migrate?: Func<[db: IDBDatabase]>): DatabaseStorage {
  return {
    connect: async <TData>(store: DatabaseStorageStore) => {
      const database = await storageApi.open(name, version, migrate);

      const close = () => {
        database.close();
      };

      return {
        database,

        readAll: () => storageApi.readAll(database, store),
        read: (key: string) => storageApi.read(database, store, key),
        readBy: (predicate: Predicate<TData>) => storageApi.readBy(database, store, predicate),
        create: (data: TData) => storageApi.create(database, store, data),
        update: (data: Partial<TData>) => storageApi.update(database, store, data),
        updateBy: (predicate: Predicate<TData>, data: Partial<TData>) => storageApi.updateBy(database, store, predicate, data),
        delete: (key: string) => storageApi.delete(database, store, key),
        deleteBy: (predicate: Predicate<TData>) => storageApi.deleteBy(database, store, predicate),

        close,
        [Symbol.dispose]: close,
      };
    },
  };
}
